<template>
	<div class="rq-avatar">
		<template v-if="image">
			<img :src="image" class="image-icon--active" />
		</template>
		<template v-else>
			<div class="no-image">
                <FontAwesomeIcon icon="far fa-user" />
			</div>
		</template>
	</div>
</template>
<script>

export default {
	name: "Avatar",
	components: {},
	mixins: [
	],
	props: {
		image: String
	},
	data() {
		return {};
	},
	computed: {
	},
	methods: {
		// getIconPerson() {
		// 	return require("@/assets/person.png");
		// },
	}
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

	.rq-avatar {
		height: 26px;
		width: 26px;
		justify-content: center;
		align-items: center;
		border: 1px solid gray;
		border-radius: 100px;
        background: transparent;
        display: flex;
        flex-direction: column;
        overflow: hidden;
	}

	img {
		height: 26px;
        width: 26px;
        border-radius: 100px;
	}

	.no-image {
        justify-content: center;
        align-items: center;
        // opacity: 0.25;
        background: #fff;
        width: 100%;

        display: flex;
        flex-direction: column;

        flex: 1;
        height: 100%;

        border-radius: 100px;
	}

	.image-icon--default {
		height: 26px;
		width: 26px;
        color: dimgray;

        flex: 1;
	}
</style>
